// Site entry — loaded by every HTML page.
// Global styles are loaded via <link rel="stylesheet"> in each HTML <head>
// to avoid a flash of unstyled content. This entry only handles the
// lazy-loaded React widget.

if (document.querySelector("[data-sde-picker]")) {
  import("../../widget/main");
}
